import castArray from 'lodash/castArray'

/**
 * Coerce a URL param value (string | string[]) into a typed array.
 * Returns undefined for empty/null/undefined inputs.
 *
 * Useful when converting useSearchParams URL state to typed API DTO arrays,
 * since URL params always arrive as `string | string[]`.
 *
 * @example
 * toUrlParamArray<ApplicationStatus>(params.carrierApplicationStatus)
 * // undefined | ApplicationStatus[]
 */
export const toUrlParamArray = <T>(
  value: string | string[] | undefined
): T[] | undefined =>
  !value || (Array.isArray(value) && !value.length)
    ? undefined
    : (castArray(value) as unknown as T[])

export const isValidHttpUrl = (text: string) => {
  try {
    const url = new URL(text)
    return url.protocol === 'http:' || url.protocol === 'https:'
  } catch (err) {
    return false
  }
}

/**
 * Returns the last path segment from a URL.
 * @example getLastPathSegment('https://enrollment.dev.surecolabs.com/qle-cart') // 'qle-cart'
 */
export const getLastPathSegment = (url: string): string => {
  const segments = new URL(url).pathname.split('/').filter(Boolean)
  return segments.at(-1) ?? ''
}
